import { TOAST_ROOT_ID } from 'utils/fnPortalRoot';

const SKIPPED_TAGS = ['SCRIPT', 'STYLE', 'LINK', 'NOSCRIPT', 'TEMPLATE'];

const inertCounts = new Map<Element, number>();
const inertBeforeDialogs = new WeakSet<Element>();

const acquire = (element: Element) => {
    const count = inertCounts.get(element) ?? 0;

    if (count === 0) {
        if (element.hasAttribute('inert')) {
            inertBeforeDialogs.add(element);
        } else {
            element.setAttribute('inert', '');
        }
    }

    inertCounts.set(element, count + 1);
};

const release = (element: Element) => {
    const count = inertCounts.get(element) ?? 0;

    if (count > 1) {
        inertCounts.set(element, count - 1);
        return;
    }

    inertCounts.delete(element);

    if (inertBeforeDialogs.has(element)) {
        inertBeforeDialogs.delete(element);
    } else {
        element.removeAttribute('inert');
    }
};

export const getBackgroundElements = (dialog: Element, excluded: Element[] = []): Element[] => {
    const background: Element[] = [];
    let node = dialog;

    while (node.parentElement && node !== document.body) {
        const current = node;

        Array.from(current.parentElement.children).forEach((sibling) => {
            if (
                sibling !== current &&
                !SKIPPED_TAGS.includes(sibling.tagName) &&
                sibling.id !== TOAST_ROOT_ID &&
                !excluded.some((element) => sibling === element || sibling.contains(element))
            ) {
                background.push(sibling);
            }
        });

        node = current.parentElement;
    }

    return background;
};

export const inertBackground = (dialog: Element, excluded: Element[] = []): (() => void) => {
    const background = getBackgroundElements(dialog, excluded);

    background.forEach(acquire);

    return () => {
        background.forEach(release);
    };
};
